import React from 'react';
import Quote from '@components/sections/Quote/indexCompose';
import * as styles from './style.module.scss';
const {
  boxSection,
  boxSection__boxes,
  boxSection__box
} = styles;

const BoxWithNumbers = ({ content }) => {

  return (
    <section className={boxSection}>
      <h4>{content.title}</h4>
      <div className={boxSection__boxes}>
        {content.box1Number && content.box1Text &&
          <>
            <div className={`${boxSection__box} background--white`}>
              <h3>{content.box1Number}</h3>
              <p>{content.box1Text}</p>
            </div>
          </>
        }
        {content.box2Number && content.box2Text &&
          <>
            <div className={`${boxSection__box} background--white`}>
              <h3>{content.box2Number}</h3>
              <p>{content.box2Text}</p>
            </div>
          </>
        }
        {content.box3Number && content.box3Text &&
          <>
            <div className={`${boxSection__box} background--white`}>
              <h3>{content.box3Number}</h3>
              <p>{content.box3Text}</p>
            </div>
          </>
        }
      </div>
      {content.quote && 
      <Quote
        key={content.quote.index} 
        text={content.quote.quoteText.internal.content}
        icon={content.quote.icon?.svg?.originalContent}
        author={{
          name: content.quote.authorName,
          position: content.quote.authorPosition,
          avatar: content.quote.authorProfilePicture,
        }}
        type={content.quote.type}
        isNumbers={true}
      />
      }
    </section>
  )
}

export default BoxWithNumbers;
